import Cookies from 'js-cookie'
// https://segment.com/docs/connections/spec/ecommerce/v2/
export const useProductAddedTracking = (props) => {
  const {
    currency,
    locale,
    checkoutId,
    productId,
    variantId,
    sku,
    name,
    variant,
    price,
    quantity,
    value,
    thumbnailImage,
    viewType,
    sectionType,
  } = props
  const fbc = Cookies.get('_fbc')
  const fbp = Cookies.get('_fbp')

  if (typeof window !== 'undefined' && window.analytics) {
    window.analytics.track('Product Added', {
      currency,
      locale,
      cart_id: checkoutId,
      product_id: productId,
      variant_id: variantId,
      sku: sku,
      name: name,
      variant: variant,
      price: price,
      quantity: quantity,
      brand: 'Stox',
      category: 'Socks',
      value: value,
      image_url: thumbnailImage && `https:' + ${thumbnailImage.file.url}`,
      sectionType,
      viewType,
      branch: window?.phill?.BRANCH,
      action_source: "website",
      fbc: fbc || null,
      fbp: fbp || null
    })
  }
}
